var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 2.522a2.523 2.523 0 015.043 0c0 1.392-1.13 2.545-2.521 2.545C1.13 5.067 0 3.914 0 2.522zM20.995 21H21v-7.703c0-3.767-.811-6.67-5.216-6.67-2.118 0-3.539 1.162-4.119 2.264h-.06V6.979H7.427V21h4.349v-6.942c0-1.828.346-3.595 2.61-3.595 2.23 0 2.263 2.086 2.263 3.712V21h4.345zM.347 6.98H4.7V21H.347V6.98z","fill":"#fff"}));
}

Linkedin.defaultProps = {"fill":"none","viewBox":"0 0 21 21"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
